import { Button, ButtonProps } from 'components/elements/Button/Button';
import { CaretLeftIcon } from 'components/icons/CaretLeft';

export const CaretLeftButton = (props: ButtonProps) => (
  <Button startAdornment={<CaretLeftIcon />} {...props} />
);
